$(document).on('turbo:load turbo:render', () => {

    $(".total-container").hide();
    $(".checkbox-total-table").find(":checkbox").each((i, el) =>{
        let $el = $(el);
        $el.on("change", () =>{
            calculateTotal()
        })
    });
        //@ts-ignore
    
});


function  calculateTotal() {
    let total = 0;
    let count = 0;
    $(".checkbox-total-table").find(":checkbox").not(".multi-check-box").each((i , el) =>{
        let $el = $(el);
        //@ts-ignore
        if (el.checked) {
            total += 100;
            count +=1
        };
    });
    let totalString = `${total}`;
    let totalDisplay;

    totalDisplay = "$" + totalString + ".00";
    if (count > 0){
        $(".total-container").show();
    }
    else{
        $(".total-container").hide();

    }
    $(".total").html(totalDisplay);
    //@ts-ignore
    $(".total-count").html(count);


}